import { SelectionChangedEvent } from "ag-grid-community";
import { RequestServiceCodeEntity } from "domain/entity/RequestServiceCode/RequestServiceCodeEntity";
import { transferRowData } from "presentation/constant/AuditLog/AuditLogMaintenanceColumnDefinition";
import { INITIAL_REQUEST_SERVICE_CODE_COL_DEF } from "presentation/constant/RequestServiceCode/RequestServiceCodeColumnDefinition";
import { RequestServiceCodeConstant } from "presentation/constant/RequestServiceCode/RequestServiceCodeConstant";
import { useRequestServiceCodeVM } from "presentation/hook/RequestServiceCode/useRequestServiceCodeVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useRequestServiceCodeTracked } from "presentation/store/RequestServiceCode/RequestServiceCodeProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useMemo, useRef } from "react";

const RequestServiceCodeTablePanel: React.FC = () => {
    const [requestServiceCodeState] = useRequestServiceCodeTracked();
    const requestServiceCodeStateVM = useRequestServiceCodeVM();
    const gridRef: any = useRef(null);
    const { requestServiceCodeList } = requestServiceCodeState;
    const [anaInfoState] = useANAInfoTracked();
    const { allowCreate } = anaInfoState;

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        requestServiceCodeStateVM.updateSelectedRows(selectedRows);
    }, [requestServiceCodeStateVM])

    const handleRowDoubleClick = useCallback((entity: RequestServiceCodeEntity) => {
        requestServiceCodeStateVM.onRowDoubleClick(entity);
    }, [requestServiceCodeStateVM])

    const handleAdd = useCallback(() => {
        requestServiceCodeStateVM.onAddClick();
    }, [requestServiceCodeStateVM]);

    const memoTable = useMemo(() => {
        return (
            <NbisTable
                id='audit-log-table'
                isNewColumnSetting={true}
                headerLabel={RequestServiceCodeConstant.TITLE}
                columns={INITIAL_REQUEST_SERVICE_CODE_COL_DEF}
                data={transferRowData(requestServiceCodeList ?? [])}
                showPaginator={false}
                editable={false}
                showAddIcon={allowCreate}
                onAddClick={handleAdd}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                handleSelectionChanged={handleSelectionChange}
                onRowDoubleClick={(e: any, entity: RequestServiceCodeEntity) => handleRowDoubleClick(entity)}
                isRowHighligted={true}
                gridHeight="customHeight"
                customHeight="calc(100vh - 75px)"
                ref={gridRef}
            />
        );
    }, [allowCreate, handleAdd, handleRowDoubleClick, handleSelectionChange, requestServiceCodeList])

    return <><TableWrapper>
        {memoTable}
    </TableWrapper>
    </>;
}

export default memo(RequestServiceCodeTablePanel);
